import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService, ApiResult } from './base.service';
import { Observable } from 'rxjs';
import { TasacionArchivo } from '../models/TasacionArchivo';
import { Visita } from '../models/visita';
import { VisitaList } from '../models/visita-list';

@Injectable({
  providedIn: 'root',
})
export class VisitasService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) {

  }

  getData(pageIndex: number, pageSize: number, sortColumn: string,
    sortOrder: string, filterColumn: string, filterQuery: string): Observable<ApiResult<VisitaList>> {

    const url = this.baseUrl + 'api/Visitas';

    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sortColumn', sortColumn)
      .set('sortOrder', sortOrder);

    if (filterQuery) {
      params = params
        .set('filterColumn', filterColumn)
        .set('filterQuery', filterQuery);
    }

    return this.http.get<ApiResult<VisitaList>>(url, { params });
  }

  get(id: number, version: number): Observable<Visita> {
    const url = `${this.baseUrl}api/Visitas/${id}/${version}`;
    return this.http.get<Visita>(url);
  }

  put(item): Observable<Visita> {
    const url = `${this.baseUrl}api/Visitas/${item.idTasacion}/${item.version}`;
    return this.http.put<Visita>(url, item);
  }

  post(item): Observable<Visita> {
    const url = `${this.baseUrl}api/Visitas/${item.idTasacion}/${item.version}`;
    return this.http.post<Visita>(url, item);
  }

  getTiposInmueble(): Observable<any> {
    const url = `${this.baseUrl}api/Visitas/TiposInmueble`;
    console.log(url);
    return this.http.get<any>(url);
  }

  getSelectOcupacion(): Observable<Map<string, string>> {
    const url = `${this.baseUrl}api/Visitas/getSelectOcupacion`;
    console.log(url);
    return this.http.get<any>(url);
  }

  getTipoTerraza(): Observable<Map<string, string>> {
    const url = `${this.baseUrl}api/Visitas/getTipoTerraza`;
    console.log(url);
    return this.http.get<any>(url);
  }

  getTipoCalefaccion(): Observable<Map<string, string>> {
    const url = `${this.baseUrl}api/Visitas/getTipoCalefaccion`;
    console.log(url);
    return this.http.get<any>(url);
  }

  getTipoGaraje(): Observable<Map<string, string>> {
    const url = `${this.baseUrl}api/Visitas/getTipoGaraje`;
    console.log(url);
    return this.http.get<any>(url);
  }

  finalizarVisita(id: number, version: number) {
    const url = `${this.baseUrl}api/Visitas/finalizarVisita/${id}/${version}`;
    console.log(url);
    return this.http.post(url, null);
  }

  getFicherosVisita(id: number, version: number, estancia: number ): Observable<TasacionArchivo[]> {{
    const url = `${this.baseUrl}api/Visitas/Ficheros/GetFicherosVisitaList/${id}/${version}/${estancia}`;
    console.log('cargar fotos estancia ->' + url);
    return this.http.get<TasacionArchivo[]>(url);
  }
}
}
